import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { GetmIconVariant } from './../../services/getm-icon/getm-icon.service';

@Pipe({
  name: 'checkIcon'
})
export class CheckIconPipe implements PipeTransform {

  private readonly basePath = 'assets/figma/icons';

  constructor(private http: HttpClient) { }

  /**
   * Verifica si el origen del icono existe en el path o es nativo de ionicons
   * @param nombre Nombre del icono
   * @param variant Variante: 'filled' o 'outline'
   * @returns { src: string, name: string } Ruta del archivo SVG o nombre del icono nativo
   */
  async transform(nombre: string, variant: GetmIconVariant = 'outline') {
    const serverUrl = window.location.origin;
    const path = `${this.basePath}/${variant}/${nombre}.svg`;
    const fullUrl = `${serverUrl}/${path}`;
    try {
      await firstValueFrom(this.http.get(fullUrl, { responseType: 'text' }));
      return { src: path, name: null };
    } catch (error: any) {
      return { src: null, name: nombre };
    }
  }
}
